import React from "react";
import { getOr } from "lodash/fp";
import { PropTypes } from "prop-types";
import { addArtistLinks } from "../../../../constants/linkDefinitions";
import Links from "../../../input/links/links";
import FormBox from "../../../presentational/page/formBox";
import { connect } from "react-redux";
import { mainStateKey } from "../../../../constants/constants";
import SearchMissingLinkButton from "../../../presentational/buttons/searchMissingLinkButton";
import OpenAllLinksButton from "../../../presentational/buttons/openAllLinksButton";

const LinksBox = ({ artistName, showOpenAllLinksButton = true }) => {
  const mainLinks = addArtistLinks.mainLinks;
  const headerButtons = [
    <SearchMissingLinkButton
      key={1}
      connectedTo={"formData.links"}
      allEntityLinks={addArtistLinks.mainLinks}
      entityName={artistName}
    />,
  ];

  if (showOpenAllLinksButton) {
    headerButtons.push(<OpenAllLinksButton key={2} connectedTo={"formData.links"} />);
  }

  return (
    <FormBox title="Links" headerContent={headerButtons}>
      <div className="box-body">
        <div className="form-horizontal">
          <Links
            entityName={artistName}
            linkInputData={mainLinks}
            name="formData.links"
            oldLinksName="formData.oldLinks"
          />
        </div>
      </div>
    </FormBox>
  );
};

LinksBox.propTypes = {
  artistName: PropTypes.string,
  showOpenAllLinksButton: PropTypes.bool,
};

const mapStateToProps = state => {
  return { artistName: getOr(null, `${mainStateKey}.formData.name.name`, state) };
};

export default connect(mapStateToProps)(LinksBox);
